import { FileDocument } from '../types';
import getServerBaseUrl from '../utils/getServerBaseUrl.platform';
import requestWithAuth from '../utils/requestWithAuth.platformIncludingExtension';
import background from './portalGates/toBackground';

export const getFilePath = (docId?: FileDocument['parsed_doc_id']) => {
  return `file/${docId}`;
};

export const loadDocument = async (docId?: FileDocument['parsed_doc_id']): Promise<Blob> => {
  // Check if the document already exists in storage
  const item: Blob | null = await background.getCacheItem(getFilePath(docId));
  if (item !== null) {
    return item;
  }
  const response = await requestWithAuth(`${getServerBaseUrl()}/reader/document_raw_content/${docId}`, {
    credentials: 'include',
    method: 'GET',
    mode: 'cors',
  });
  const blob = await response.blob();
  await background.setCacheItem(getFilePath(docId), blob);
  return blob;
};

export const downloadFile = async (filename: string, content: string | Uint8Array, mimeType: string) => {
  const link = document.createElement('a');
  const file = new Blob([content], { type: mimeType });
  link.href = URL.createObjectURL(file);
  link.download = filename;
  link.click();
  URL.revokeObjectURL(link.href);
};
